// extracted by mini-css-extract-plugin
module.exports = {"franchiseJourneyBecomeOwner":"tPp36"};